<template>
  <div>
    <button
      class="bg-white w-full relative overflow-hidden sm:rounded-md border dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 dark:border-1"
      @click="createLink"
    >
      <div class="w-full p-4 flex items-center text-left cursor-pointer">
        <Loader v-if="isLoading" class="w-8 h-8 mx-auto" />

        <template v-else>
          <Icon
            name="MdiWhatsapp"
            class="flex-shrink-0 w-7 h-7 me-3 text-whatsapp"
          />
          <p class="font-medium text-sm leading-tight break-word">
            {{ $t("share_cart_on_whatsapp") }}
          </p>
        </template>
      </div>
    </button>
    <ShareModal />
  </div>
</template>

<script>
import { mapState } from "pinia";
import ShareModal from "./modal.vue";
import createWhatsAppMessage from "@/graph/store/create-whatsapp-message.gql";
import { useCartStore } from "@/store/cart";
import { useBizStore } from "@/store/index";
import { useVepaarStore } from "@/store/store";
export default {
  components: {
    ShareModal,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState(useCartStore, ["cart", "cartProducts"]),
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useBizStore, ["url"]),
  },
  methods: {
    createLink() {
      this.isLoading = true;
      this.$apollo
        .mutate({
          mutation: createWhatsAppMessage,
          variables: {
            input: {
              storeHash: this.hash,
              products: this.cartProducts,
            },
          },
        })
        .then(
          ({
            data: {
              createWhatsAppMessage: { messageHash },
            },
          }) => {
            const encoded = encodeURIComponent(
              `${this.url}/cart?hash=${messageHash}`
            );
            /**
             * For IOS, below link works fine ( https://wa.me did not work as it requires phone number )
             * IOS also blocks programmatically opening new tab using js. therefore opening modal with user click
             */

            this.$nuxt.callHook("modal-open", "whatsapp-share", {
              link: `https://api.whatsapp.com/send?text=${encoded}`,
            });
          }
        )
        .catch(() => {
          alert("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
